import { mapActions, mapGetters } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyNumberCardPostpaidAccountBalance',

  props: {
    accountBalance: {
      type: String,
      required: true,
    },
    accountBalanceCurrent: {
      type: String,
      required: true,
    },
    interest: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        ballance: require("@/assets/wallet.svg"),
      }
    }
  },
  computed: {
    ...mapGetters(['subscriber', 'paymentsError']),
    shouldShowAccountBalance() {
      return parseFloat(this.accountBalance) > 0;
    },
  },
  methods: {
    ...mapActions(['genratePaymentToken']),
    goToPayments(type) {
      // Backend sam wylicza kwotę i buduje tytuł transakcji na podstawie
      // danych zalogowanego abonenta - stąd wysyłamy tylko identyfikator
      // typu płatności (patrz App\Http\Controllers\Payments::tokenGenerate()).
      this.genratePaymentToken({ type });
    },
    formatErrorDate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString.replace(' ', 'T'));
      if (Number.isNaN(date.getTime())) return dateString;
      return date.toLocaleString('pl-PL', {
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyNumberCard/MyNumberCardPostpaidAccountBalance/component.js